import { Box } from "@mui/material";
import "./App.css";
import RouteComponent from "./routes/Route";
import Notification from "./components/notification/notification";
import Footer from "./components/Footer";
import Loader from "./components/Loader";
import theme from "./theme";
import { ThemeProvider } from "@mui/styles";
const App = () => {
	return (
    <>
    <ThemeProvider theme={theme}>
      {/* <Box sx={{ display: "flex" }}> */}

        <RouteComponent />
				<Notification />
				<Loader/>
      {/* </Box> */}
      </ThemeProvider>
    </>
  );
};
export default App;
